import React, { Fragment, useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { io } from "socket.io-client";
import {
	fetchAllUnreadNotifications, getNotificationById, updateNotification
} from '../../store/actions';
import NotificationMsg from './NotificationMsg';

const NotificationSocket = (props) => {
	const [socketConnection, setSocketConnection] = useState(null)
	const [newNotification, setNewNotification] = useState(null)
	const appId = props?.appId;
	// Track current topic name for proper cleanup
	const currentTopicRef = useRef(null);

	useEffect(() => {
		props.fetchAllUnreadNotifications(appId);

		const notificationUrl = process.env.REACT_APP_NOTIFICATION_SERVICE_URL;

		// For local uncomment next two lines
		// const socket = io('https://platform-dev.dsilo.ai', {
		// 	path: "/notification-service/api/v1/socket.io",
		const socket = io('', {
			path: notificationUrl + '/socket.io',
			reconnection: true,
			reconnectionDelay: 1000,
			reconnectionDelayMax: 5000,
			reconnectionAttempts: 3,
			transports: ['websocket']
		});

		socket.on('connect', () => {
			console.log(`Client connected: ***  ${socket.id}, AppId: ${appId}`)
			setSocketConnection(socket)
		});

		socket.on('disconnect', (reason) => {
			console.log(`Client disconnected:  *** ${reason}`);
			setSocketConnection(null)
		});

		socket.on('connect_error', (reason) => {
			console.log(`Client connect_error: *** ${reason}`)
			// if(reason === 'Error: websocket error') {
			// 	setTimeout(() => {
			// 		socket.connect();
			// 	}, 1000);
			// } else 
			setSocketConnection(null)
		});

		return () => {
			// Remove all listeners for these events (don't pass empty functions!)
			socket.off('connect');
			socket.off('disconnect');
			socket.off('connect_error');
			socket.disconnect();
			setSocketConnection(null);
		};
	}, []);

	useEffect(() => {
		const memberId = props.members?._id || '';
		if (socketConnection && memberId && appId) {
			// Clean up previous topic listener if exists
			if (currentTopicRef.current && socketConnection) {
				socketConnection.off(currentTopicRef.current);
			}
			
			const notificationTopicName = `${appId}-${memberId}`;
			currentTopicRef.current = notificationTopicName;
			
			// Removed console.log to prevent memory leaks from held references
			socketConnection.on(notificationTopicName, (newNotification) => {
				console.log(`new notification $$$$ :::: **** `, newNotification);
				if(newNotification?._id) {
					setNewNotification(newNotification)
				} else if(newNotification?.value) {
					setNewNotification(newNotification?.value)
				}
			});
		}

		return () => {
			// Remove listener using ref to avoid stale closure
			if (socketConnection && currentTopicRef.current) {
				socketConnection.off(currentTopicRef.current);
				currentTopicRef.current = null;
			}
		};
	}, [socketConnection, props?.members, appId]);

	useEffect(() => {
		if (newNotification) {
			// Access notifications data directly from props without deep cloning
			// This prevents unnecessary memory allocation
			const notificationsData = props.notifications?.data || [];
			
			if (newNotification?.process && newNotification?._id && newNotification?.npId) {
				props.updateNotification(newNotification, true);
			} else if (newNotification?.subprocess && newNotification?.processId && newNotification?.npId) {
				const existingNotification = notificationsData.find(
					ntf => ntf?._id === newNotification?.processId && ntf?.npId === newNotification?.npId,
				);
				if (existingNotification) {
					props.updateNotification(newNotification)
				} else {
					const payload = {
						processId: newNotification?.processId,
						appId
					}
					props.getNotificationById(payload);
				}
			}
			toast(<NotificationMsg notification={newNotification} />);
		}
	}, [newNotification])


	return (
		<>
			{props.children}
		</>
	)
}

const mapStateToProps = state => {
	return {
		appDetails: state.appConfig,
		app: state.app,
		appConfig: state.form.document?.appConfig,
		notifications: state.notifications,
		members: state.appConfig.members,
		user: state.user
	};
};

const mapDispatchToProps = {
	fetchAllUnreadNotifications,
	getNotificationById,
	updateNotification
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationSocket);